// ThankYou.js
import React from 'react';
import '../index.css';

const ThankYou = () => {
  return (
    <div className="thank-you-container">
      <div className="thank-you-content">
        <div className="checkmark-container">
          <svg className="checkmark" viewBox="0 0 52 52">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <h1>Thank You!</h1>
        <p className="thank-you-message">
          Your feedback has been successfully submitted. We truly appreciate you taking the time to complete our survey.
        </p>
        <p className="thank-you-submessage">
          Your responses will help us improve our workplace and services.
        </p>
        <div className="thank-you-actions">
          <button 
            className="thank-you-button"
            onClick={() => window.location.reload()}
          >
            Start New Survey
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;